import type { CategoryContent } from '../../row.js';

/** Aardrijkskunde & aardsystemen, tweede reeks. Juiste optie eerst; wordt bij build geroteerd. */
export const MORE_GEOGRAPHY: CategoryContent = {
  msc: [
    [
      'Wat drukt de Bowen-ratio uit?',
      [
        'De verhouding tussen voelbare en latente warmteflux van een oppervlak',
        'De verhouding tussen netto straling en bodemwarmteflux',
        'De verhouding tussen werkelijke en potentiële verdamping',
        'De verhouding tussen albedo en oppervlakte-emissiviteit',
      ],
      0,
      'Hoog boven een woestijn, laag boven open water. Het eerste getal waar je naar kijkt bij het opsplitsen van een energiebalans.',
    ],
    [
      'Waardoor ontstaat een regenschaduw?',
      [
        'Gedwongen opstijging onttrekt vocht aan de windzijde',
        'Hogere oppervlaktealbedo op de lijzijde onderdrukt convectie',
        'Koudeluchtafvoer verdringt vochtige lucht uit de leivallei',
        'Lagere luchtdruk op hoogte voorkomt condensatie',
      ],
      0,
      'De Atacama, de Patagonische steppe en het Great Basin zijn allemaal hetzelfde mechanisme op verschillende bergketens.',
    ],
    [
      'Welke criteria gebruikt de Koppen-classificatie als voornaamste basis?',
      [
        'Maandelijkse drempelwaarden voor temperatuur en neerslag',
        'Netto stralingsbalans en dominante bronregio\'s van luchtmassa\'s',
        'Potentiële verdamping ten opzichte van bodemvochtopslag',
        'Breedtegraadzones gecorrigeerd voor continentaliteit en hoogte',
      ],
      0,
      'De vegetatiekalibratie is waarom de grenzen soms arbitrair aanvoelen in klimaattermen - ze zijn getrokken op biomen, niet op isothermen.',
    ],
    [
      'Waardoor wordt de thermohaliene circulatie aangedreven?',
      [
        'Dichtheidsverschillen door temperatuur- en zoutgehaltecontrasten',
        'Windschuifspanning op het oceaanoppervlak in de passaatgordel',
        'Getijmenging over midoceanische ruggen en continentale plateaus',
        'De Corioliskracht op westelijke grensstromen',
      ],
      0,
      'Diep water ontstaat waar oppervlaktewater koud en zout genoeg is om te zinken - de Labradorzee en de Groenlandse Zee, en rond Antarctica.',
    ],
    [
      'Waardoor ontstaat een karstlandschap?',
      [
        'Oplossing van goed oplosbaar gesteente, voornamelijk kalksteen',
        'Vorstverwering van gescheurd gesteente onder periglaciale omstandigheden',
        'Deflatie en afslijting van gesteente door windgedragen zand',
        'Differentiële compactie van los sediment boven hoger gelegen gesteente',
      ],
      0,
      'Zinkgaten, grotten en verdwijnende beken. Ook waarom karstwatervoerende lagen zo kwetsbaar zijn voor vervuiling - er is nauwelijks filtering.',
    ],
    [
      'Op ongeveer welke breedtegraad daalt de Hadley-cel neer?',
      ['30 graden', '10 graden', '50 graden', '60 graden'],
      0,
      'Daarom liggen de grote subtropische woestijnen in een band rond die breedtegraad op beide halfronden.',
    ],
    [
      'Wat onderscheidt een delta van een estuarium?',
      [
        'Een delta ontstaat waar sedimentaanvoer de afvoer overtreft; een estuarium is een verdronken riviermond',
        'Een delta is getijgebonden en een estuarium niet',
        'Een delta komt voor op passieve randen en een estuarium op actieve',
        'Een delta is overal zoetwater en een estuarium overal zout',
      ],
      0,
      'Beide kunnen getijgebonden zijn. De Nijl bouwt zich uit; de Thames is overstroomd - een verschil in sedimentbudget, niet in het water zelf.',
    ],
    [
      'Waar verwijst isostasie naar?',
      [
        'Het drijvende evenwicht van de aardkorst op een dichtere, vervormbare mantel',
        'De balans tussen erosie en opheffing in een berggebied',
        'Het evenwichtsprofiel dat een rivier aanneemt tussen bron en mond',
        'De steady state tussen zeebodemspreiding en subductie',
      ],
      0,
      'Daarom staat dikke korst hoog, drukken ijskappen het land eronder in, en stijgt de Baltische bodem nog steeds.',
    ],
    [
      'Wat is de betekenis van de 4,2 ka-gebeurtenis?',
      [
        'Een abrupte verdrogingsperiode die in verband wordt gebracht met de ontwrichting van meerdere bronstijdbeschavingen',
        'De uiteindelijke afwatering van de Noord-Amerikaanse pro-glaciale meren',
        'Het begin van het huidige interglaciaal op het noordelijk halfrond',
        'De piek van de zeespiegelstijging in het Holoceen in het Middellandse Zeegebied, vastgelegd in verzonken kustafzettingen',
      ],
      0,
      'Het is de grens van het Meghalayaan. Of het de toegeschreven ineenstortingen veroorzaakte, of er alleen mee samenviel, wordt hard betwist.',
    ],
    [
      'Hoe wordt loess het best beschreven?',
      [
        'Door de wind afgezet silt, doorgaans van glaciale of woestijnrand-oorsprong',
        'Ongesorteerd puin, door gletsjers vervoerd en achtergelaten aan een ijsrand',
        'Fijnkorrelig meersediment dat in jaarlagen is afgezet',
        'Verweerde vulkanische as die ter plekke tot klei is omgezet',
      ],
      0,
      'De loessgordels van Noord-China, de Mississippi en Oekraïne horen bij de productiefste bodems die er zijn, en bij de meest erosiegevoelige.',
    ],
  ],
  phd: [
    [
      'Waarvan bepaalt de Rossby-deformatiestraal de schaal?',
      [
        'De lengte waarop rotatie begint te domineren over drijfkracht in een gestratificeerde vloeistof',
        'De golflengte van een planetaire golf in de mid-breedtegraad westenwinden',
        'De diepte van de oceanische gemengde laag onder constante windforcering',
        'De horizontale omvang van de wolkenmuur van een tropische cycloon',
      ],
      0,
      'Daarom zijn oceaanwervels tientallen kilometers breed en atmosferische wervels honderden - de stratificatie en de schaalhoogte verschillen.',
    ],
    [
      'In welke richting verplaatst het Ekman-transport oppervlaktewater op het noordelijk halfrond?',
      [
        'Negentig graden naar rechts van de wind',
        'Recht met de wind mee, exponentieel afnemend met de diepte',
        'Negentig graden naar links van de wind',
        'Langs isobaren, in geostrofisch evenwicht met het drukveld',
      ],
      0,
      'Dat is wat kustopwelling laat werken: een langskustwind drijft oppervlaktewater zeewaarts en koud water neemt de plaats in.',
    ],
    [
      'Wat brengt het Budyko-raamwerk met elkaar in verband?',
      [
        'De verdeling van neerslag tussen verdamping en afvoer, als functie van ariditeit',
        'Planetair albedo en de gemiddelde mondiale oppervlaktetemperatuur',
        'Bodemkoolstofomzetting en de gemiddelde jaartemperatuur, via een exponentiële temperatuurgevoeligheid',
        'Sedimentopbrengst en bekkenreliëf en neerslag',
      ],
      0,
      'Een opmerkelijk robuuste eenparametercurve, waardoor afwijkingen ervan worden gezien als diagnostisch voor landgebruik of klimaatverandering.',
    ],
    [
      'Waar verwijst het begrip "critical zone" in de aardoppervlaktewetenschap naar?',
      [
        'De laag nabij het oppervlak, van vegetatiedak tot grondwater, waar gesteente, water, lucht en leven op elkaar inwerken',
        'De zone van maximale schuifspanning aan de basis van een gletsjer',
        'Het dieptebereik waar bodemkoolstof het gevoeligst is voor opwarming',
        'De band van breedtegraden waar monsoenuitval de grootste interjaarlijkse neerslagvariabiliteit vertoont',
      ],
      0,
      'Een bewust integrerende framing, en een die aanzienlijke financiering voor observatoria kreeg met het argument dat de disciplines niet met elkaar praatten.',
    ],
    [
      'Wat is een knikpunt en waarom is het van belang?',
      [
        'Een breuk in het lengteprofiel van een rivier die stroomopwaarts migreert en veranderingen in basisniveau of opheffing vastlegt',
        'Het punt waarop een geulbedding overgaat van gesteente- naar alluviale controle',
        'De samenvloeiing waar twee beken van gelijke orde samenkomen, wat de orde van de geul stroomafwaarts verhoogt',
        'De hoogte waarop de accumulatie en ablatie van een gletsjer in balans zijn',
      ],
      0,
      'De snelheid van een knikpunt is hoe tektonische signalen uit topografie worden afgelezen, en het stream-power-model zet het een in het ander om.',
    ],
    [
      'Hoe wordt de Jonge Dryas doorgaans verklaard?',
      [
        'Een smeltwaterpuls die de diepwatervorming in de Noord-Atlantische Oceaan verstoort',
        'Een reeks grote tropische vulkaanuitbarstingen',
        'Een orbitaal minimum in de zomerinstraling op het noordelijk halfrond',
        'Een afname van de zonneactiviteit die samenvalt met een grand minimum',
      ],
      0,
      'De routering van de afvoer van Lake Agassiz is het klassieke mechanisme; de inslaghypothese is herhaaldelijk voorgesteld en herhaaldelijk betwist.',
    ],
    [
      'Wat betekent de term "teleconnectie" in de klimatologie?',
      [
        'Een statistisch robuuste samenhang tussen klimaatanomalieën in ver van elkaar gelegen regio\'s',
        'De warmteoverdracht tussen halfronden door de atmosferische circulatie',
        'De verspreiding van een tsunami over een heel oceaanbekken',
        'De koppeling van stratosferische en troposferische circulatie boven een pool',
      ],
      0,
      'ENSO en de Noord-Amerikaanse winter is het klassieke voorbeeld; de Noord-Atlantische Oscillatie is een ander.',
    ],
    [
      'Wat meet kosmogene nuclidendatering van een landvorm?',
      [
        'Opgebouwde blootstelling aan kosmische straling aan of nabij het oppervlak',
        'De tijd sinds het laatste thermische resetten van het luminescentiesignaal van een mineraal',
        'Het verval van kalium naar argon binnen een vulkanisch mineraal',
        'De verblijftijd van water in een grondwaterlichaam',
      ],
      0,
      'Beryllium-10 in kwarts is het werkpaard. Het maakte het mogelijk glaciale chronologieën op te bouwen op basis van zwerfkeien in plaats van organisch materiaal.',
    ],
    [
      'Wat is de voornaamste moeilijkheid bij het toeschrijven van een enkele extreme weersgebeurtenis aan klimaatverandering?',
      [
        'Attributie is probabilistisch',
        'Observatiereeksen zijn te kort om enige basislijn vast te stellen',
        'Klimaatmodellen kunnen synoptische-schaal systemen niet oplossen',
        'Natuurlijke variabiliteit en geforceerde verandering kunnen zelfs in principe niet worden gescheiden',
      ],
      0,
      'Daarom rapporteert de literatuur een toe te schrijven risicofractie in plaats van een ja-of-nee-antwoord, en daarom wordt de framing steeds verkeerd weergegeven.',
    ],
    [
      'Waarin verschillen de World Reference Base en de USDA-bodemtaxonomie voornamelijk?',
      [
        'De reference base classificeert op waarneembare diagnostische horizonten; het USDA-systeem leunt op afgeleide genese en klimaat',
        'Het ene systeem geldt alleen voor landbouwgronden en het andere voor alle landoppervlakken',
        'Het ene is uitsluitend gebaseerd op textuur en het andere uitsluitend op chemie',
        'Het ene wordt alleen in Europa gebruikt en heeft geen internationale status, waardoor mondiale datasets standaard het andere gebruiken',
      ],
      0,
      'Daarom kan hetzelfde profiel een Gleysol en een Aquept zijn, en daarom hebben continent-overschrijdende bodemdatasets een vertaalstap nodig.',
    ],
  ],
  professor: [
    [
      'Wat voorspelt het stream-power-insnijdingsmodel, en wat is zijn voornaamste zwakte?',
      [
        'Erosiesnelheid als machtsfunctie van stroomgebiedsoppervlak en helling',
        'Sedimentflux als lineaire functie van geulbreedte, alleen geldig in gesteentegeulen',
        'Hellingerosie als een diffuus proces, dat faalt waar aardverschuivingen dominant zijn',
        'Bekkengemiddelde denudatie op basis van reliëf alleen, dat faalt in tektonisch rustige gebieden',
      ],
      0,
      'Het is het standaard werkpaard en de exponenten zijn eigenlijk gefit in plaats van afgeleid, wat het omkeren van topografie naar opheffingsgeschiedenis omstreden maakt.',
    ],
    [
      'Wat stelt de "tektonisch aneurysma"-hypothese?',
      [
        'Geconcentreerde fluviale erosie kan snelle gesteenteopheffing en metamorfose lokaliseren door de korst te ontlasten',
        'Slabbreuk drijft plotselinge oppervlakteopheffing over een heel orogeen aan',
        'Glaciale "buzzsaw"-werking beperkt de berghoogte ongeacht het tektonische tempo',
        'Delaminatie van de onderkorst veroorzaakt plateau-instorting aan de randen',
      ],
      0,
      'Nanga Parbat en Namche Barwa zijn de typelocaties - erosie als tektonische aanjager in plaats van slechts een reactie.',
    ],
    [
      'Waarvoor is het Zebiak-Cane-model bekend?',
      [
        'Het eerste gekoppelde model dat El Nino voorspelde vanuit oceaan-atmosfeerdynamica',
        'De eerste wervel-oplossende simulatie van de Zuidelijke Oceaan',
        'Het vaststellen van de moderne parameterisatie van atmosferische convectie',
        'Het reconstrueren van Plioceen zeeoppervlaktetemperaturen uit proxies',
      ],
      0,
      '1987, en met opzet van intermediaire complexiteit. Het maakte van ENSO een voorspelbaarheidsprobleem in plaats van een statistische curiositeit.',
    ],
    [
      'Wat draagt het begrip "geodiversiteit" bij, en waarom is het omstreden?',
      [
        'Het breidt natuurbehoudredeneringen uit naar abiotische kenmerken',
        'Het meet de variatie in bodemtypen binnen een landschapseenheid',
        'Het kwantificeert het scala aan erosieprocessen dat op een helling inwerkt',
        'Het indexeert lithologische variatie voor gebruik in gevarenkartering',
      ],
      0,
      'Het praktische probleem is dat biodiversiteit telbare eenheden heeft en geodiversiteit niet, wat afwegingen bij planning moeilijk formaliseerbaar maakt.',
    ],
    [
      'Uit welk bewijs worden Bond-gebeurtenissen afgeleid, en hoe zeker zijn ze?',
      [
        'Door ijs meegevoerd puin in Holocene mariene kernen uit de Noord-Atlantische Oceaan',
        'Stofflux in Antarctisch ijskernen, betrouwbaar gedateerd door jaarlaagtelling',
        'Zuurstofisotopen uit speleothemen in monsoengebieden, wereldwijd goed gerepliceerd',
        'Boomringbreedtechronologieën van de bristlecone pine, precies jaarlijks',
      ],
      0,
      'De ongeveer 1500-jarige spacing van Bond is betwist, zowel qua statistiek als qua datering, en blijft ondanks dat de standaardverwijzing.',
    ],
    [
      'Wat verandert de "sediment routing system"-framing aan provenance-analyse?',
      [
        'Het behandelt bron-naar-put-overdracht als een signaalverwerkingsprobleem',
        'Het beperkt provenance-interpretatie tot geochemie van een enkel mineraal',
        'Het gaat uit van instantane overdracht van erosie naar afzetting',
        'Het is alleen van toepassing op mariene deltasystemen',
      ],
      0,
      'Het gevolg is onaangenaam: een stratigrafisch record bewaart mogelijk niet het klimaatsignaal dat het produceerde, als het systeem langer buffert dan de forcering duurt.',
    ],
    [
      'Hoe wordt de rol van de Antarctische Circumpolaire Stroom in het Cenozoicum betwist?',
      [
        'Of het ontstaan ervan Antarctische verijzing veroorzaakte door thermische isolatie, of volgde op CO2-gedreven afkoeling',
        'Of het al voor het Mioceen bestond, gezien de ambiguïteit van het vroege record van de Zuidelijke Oceaan',
        'Of het meer warmte transporteert dan de Golfstroom',
        'Of het door wind of door thermohaliene processen wordt aangedreven',
      ],
      0,
      'De gateway-hypothese versus de broeikasgas-hypothese. Reconstructies van CO2 uit proxies hebben de discussie aanzienlijk richting de laatste verschoven.',
    ],
    [
      'Wat is "hydrologische non-stationariteit" en waarom is het van belang?',
      [
        'De aanname dat historische afvoerstatistieken toekomstige verdelingen niet langer beschrijven, wat standaard ontwerpmethoden ongeldig maakt',
        'De tendens van rivierpeilstations om over decennia uit calibratie te lopen',
        'De seizoensvariatie van de basisafvoer in door sneeuwsmelt gedomineerde bekkens',
        'De afhankelijkheid van overstromingsfrequentie van voorafgaande bodemvochtigheid, wat elke eenvariabele frequentieanalyse ontoereikend maakt',
      ],
      0,
      'Milly et al., "Stationarity is dead". Elke honderdjaarlijkse overstromingsraming in een ontwerpnorm rust op de aanname die dit verwerpt.',
    ],
    [
      'Wat doet het onderscheid "gevoeligheid versus veerkracht" voor de analyse van geomorfologische systemen?',
      [
        'Het scheidt de omvang van de respons van een systeem van zijn vermogen om naar een vorige staat terug te keren',
        'Het onderscheidt meetfouten van werkelijke landschapsverandering',
        'Het scheidt tektonische van klimatologische forcering in een erosiesignaal',
        'Het onderscheidt gedrag van gesteente- en alluviale geulen, die verschillend reageren op dezelfde forcering',
      ],
      0,
      'Het is wat je in staat stelt te zeggen dat een landschap sterk reactief is en toch stabiel, wat tegenstrijdig klinkt totdat de twee assen gescheiden worden.',
    ],
    [
      'Waarom is het Antropoceen betwist als formele geologische eenheid?',
      [
        'De stratigrafische marker en startdatum zijn omstreden',
        'Er is geen meetbaar menselijk signaal in het sedimentaire record',
        'Het valt volledig samen met het reeds gedefinieerde Holoceen',
        'Het kan niet worden geïdentificeerd buiten terrestrische sequenties',
      ],
      0,
      'De stemming tegen het voorgestelde tijdvak in 2024 heeft niet de bruikbaarheid van het begrip beslecht - alleen de formele status, een onderscheid dat in de berichtgeving grotendeels verloren ging.',
    ],
  ],
};
